/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon16Light = forwardRef('ArrowParallelVIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.572 6.244a.5.5 0 1 1-.707-.707l2.619-2.618a1.438 1.438 0 0 1 2.032 0l2.619 2.618a.5.5 0 1 1-.707.707L5 3.816V13a.5.5 0 0 1-1 0V3.816L1.572 6.244Z" }),
        React.createElement("path", { d: "M12 12.183V3a.5.5 0 0 0-1 0v9.183L8.572 9.756a.5.5 0 1 0-.707.707l2.618 2.618a1.438 1.438 0 0 0 2.034 0l2.618-2.618a.5.5 0 1 0-.707-.707L12 12.183Z" })));
});
